export const criticalityRating: {[index: number]: string} = {
  0: 'Select Criticality Rating',
  1: '1 - Non-Production Equipment',
  2: '2 - Less Critical, With Redundancy',
  3: '3 - Less Critical, No Redundancy',
  4: '4 - Critical, With Redundancy',
  5: '5 - Critical, No Redundancy',
}
